import React from "react";
import { toast } from "react-toastify";
import { mutate } from "swr";
import { CheckboxIcon, VerticalDotsIcon } from "@aureskonnect/react-ui";
import classnames from "classnames";
import { useTranslation } from "react-i18next/";
import { useSnapshot } from "valtio";

import {
    store,
    setIsMultiDeletePeripheralModalOpened,
    setIsActionsClicked,
    setIsEdited,
    setActions,
} from "./store";
import { verifyIfPeripheralAssociate } from "@helpers/peripheralsHelpers";
import {
    setFN,
    setMessage,
} from "@components/Common/ConfirmationMultiDeleteMessage/store";

import ErrorToast from "@components/Common/ErrorTost";
import { useFetchGlobal } from "../../../api/hooks";

type actionType = {
    typeDisplay: string;
    setTypeDisplay: Function;
    selectedIds: any;
    ListNumberOrigin: any;
    setDataIsUpdated: Function;
    setIsAddBeeperClicked: Function;
};
export default function DropdownAction({
    typeDisplay,
    setTypeDisplay,
    selectedIds,
    ListNumberOrigin,
    setDataIsUpdated,
    setIsAddBeeperClicked,
}: actionType) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();
    const { isActionsClicked, isEdited, modify } = useSnapshot(store);

    const appId = "KIOSK";
    let ifPeripheralAssociateObject: {
        isPeripheralAssociate: boolean;
        appId_children: any[];
    };
    return (
        <React.Fragment>
            <div>
                <div
                    className={` cmn_drp_FRmenu ${classnames("dropdown", {})}`}
                    onClick={() => {}}
                >
                    <VerticalDotsIcon
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        style={{ cursor: "pointer" }}
                        height={25}
                        width={25}
                        fill="black"
                        className="cmn_drp_FRmenu"
                    />
                    <div
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                    >
                        <div
                            className={` dropdown-item pl-1  ${classnames("", {
                                cmn_btn_FRlistActivated:
                                    typeDisplay === "notArchived",
                                cmn_btn_FRarchived: typeDisplay === "archived",
                            })}`}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                if (isEdited === true) {
                                    setIsActionsClicked(!isActionsClicked);
                                    setActions(() => {
                                        setIsEdited(false);
                                        setTypeDisplay(
                                            typeDisplay === "notArchived"
                                                ? "archived"
                                                : "notArchived"
                                        );
                                        if (typeDisplay === "notArchived") {
                                            setIsAddBeeperClicked(false);
                                        }
                                    });
                                } else {
                                    setTypeDisplay(
                                        typeDisplay === "notArchived"
                                            ? "archived"
                                            : "notArchived"
                                    );
                                    if (typeDisplay === "notArchived") {
                                        setIsAddBeeperClicked(false);
                                    }
                                }
                            }}
                        >
                            <span className="ml-2">
                                {t(
                                    typeDisplay === "notArchived"
                                        ? "Archived(s) beeper(s)"
                                        : "Activated(s) beeper(s)"
                                )}
                                (
                                {typeDisplay === "notArchived"
                                    ? ListNumberOrigin.nbrArchived
                                    : ListNumberOrigin.nbrNotArchived}
                                )
                            </span>
                        </div>
                        {modify && (
                            <div
                                style={{ cursor: "pointer" }}
                                className={`cmn_btn_FRarchived cmn_btn_FRunarchive cmn_btn_FRarchived ${classnames(
                                    " dropdown-item pl-1 pointer__clz",
                                    {
                                        "not-allowed-icon__clz":
                                            selectedIds !== undefined &&
                                            selectedIds.length === 0,
                                    }
                                )}`}
                                onClick={async () => {
                                    let error: boolean = false;
                                    if (selectedIds.length === 1) {
                                        ErrorToast(
                                            `${t(
                                                "Attention, it is a multiple action. Please select at least two items"
                                            )!}`
                                        );
                                    } else {
                                        let canRun: boolean = true;
                                        try {
                                            for (
                                                let index = 0;
                                                index < selectedIds.length;
                                                index++
                                            ) {
                                                let item = selectedIds[index];
                                                ifPeripheralAssociateObject = await verifyIfPeripheralAssociate(
                                                    item.Id,
                                                    item.shopId,
                                                    item.franchiseID,
                                                    item.userID,
                                                    appId,
                                                    fetchGlobal
                                                );
                                                if (
                                                    ifPeripheralAssociateObject.isPeripheralAssociate
                                                ) {
                                                    canRun = false;
                                                }
                                            }
                                            if (
                                                (canRun &&
                                                    typeDisplay ===
                                                        "notArchived") ||
                                                typeDisplay === "archived"
                                            ) {
                                                setFN(async () => {
                                                    for (
                                                        let index = 0;
                                                        index <
                                                        selectedIds.length;
                                                        index++
                                                    ) {
                                                        let item =
                                                            selectedIds[index];
                                                        const link = `${process.env.REACT_APP_API_V2_URL}/settings/beeper?userId=${item.userID}&shopId=${item.shopId}&franchiseId=${item.franchiseID}&operatorId=${item.operatorId}&id=${item.Id}&isArchived=${item.isArchived}`;
                                                        const data: any = await fetchGlobal(
                                                            link,
                                                            {
                                                                headers: {
                                                                    "Content-Type":
                                                                        "application/json",
                                                                },

                                                                method:
                                                                    "Delete",
                                                            }
                                                        );
                                                        mutate(link, data);
                                                        if (data.error) {
                                                            error = true;
                                                            throw Error(
                                                                "Error!"
                                                            );
                                                        }

                                                        if (
                                                            index ===
                                                            selectedIds.length -
                                                                1
                                                        ) {
                                                            if (
                                                                error ===
                                                                    false &&
                                                                selectedIds.length >
                                                                    1
                                                            ) {
                                                                setDataIsUpdated(
                                                                    true
                                                                );

                                                                toast.success(
                                                                    `${t(
                                                                        typeDisplay ===
                                                                            "notArchived"
                                                                            ? "The device was successfully archived"
                                                                            : "The device was successfully unarchived"
                                                                    )!}`,
                                                                    {
                                                                        position:
                                                                            toast
                                                                                .POSITION
                                                                                .TOP_CENTER,
                                                                        autoClose: 2000,
                                                                        theme:
                                                                            "colored",
                                                                        closeOnClick: true,
                                                                        pauseOnHover: true,
                                                                        draggable: true,
                                                                        icon: (
                                                                            <CheckboxIcon
                                                                                height={
                                                                                    25
                                                                                }
                                                                                width={
                                                                                    25
                                                                                }
                                                                                fill="white"
                                                                            />
                                                                        ),
                                                                    }
                                                                );
                                                            }
                                                        }
                                                    }
                                                });
                                                setMessage(
                                                    t(
                                                        typeDisplay ===
                                                            "notArchived"
                                                            ? "Please confirm archivation of this device"
                                                            : "Please confirm unarchivation of this device"
                                                    )
                                                );
                                                setIsMultiDeletePeripheralModalOpened(
                                                    true
                                                );
                                            } else {
                                                ErrorToast(
                                                    t(
                                                        "Please note that you cannot archive a device associated with an application."
                                                    )
                                                );
                                            }
                                        } catch (e: any) {
                                            error = true;

                                            toast.error(
                                                `${t("There's an error")!}`,
                                                {
                                                    position:
                                                        toast.POSITION
                                                            .TOP_CENTER,
                                                    autoClose: 2000,
                                                    theme: "colored",
                                                    closeOnClick: true,
                                                    pauseOnHover: true,
                                                    draggable: true,
                                                }
                                            );
                                        }
                                    }
                                }}
                            >
                                <span className="ml-2">
                                    {typeDisplay === "notArchived"
                                        ? t("Archive")
                                        : t("Dearchive")}
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
